import { render, staticRenderFns } from "./VoucherSegmentListItem.vue?vue&type=template&id=252351d2&scoped=true"
import script from "./VoucherSegmentListItem.vue?vue&type=script&lang=js"
export * from "./VoucherSegmentListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252351d2",
  null
  
)

export default component.exports